/**
 * Created by r4zi4l on 13.05.2021
 */

const PassRewardIcon = cc.Node.extend({
    ctor: function (options) {
        this._super();
        this.options = options;
        this.passLogic = options.passLogic;
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(cleverapps.styles.PassRewardIcon.icon);

        const rewardData = options.premium ? this.passLogic.levels[options.level].premiumReward : this.passLogic.levels[options.level].reward;
        this.rewardList = new RewardsList(rewardData, { toMainWorld: this.passLogic.mission.mainWorldReward });

        const rewards = this.rewardList.listRewards();
        if (rewards.length === 1 && rewards[0].type === "units") {
            this.toolTipMsg = cleverapps.unitsLibrary.getUnitName(rewards[0].getValue());
        }
        this.createContent();
    },

    // Stages handing out several different rewards at once - a unit and a stickers pack, say -
    // have no one reward to picture, so they show the chest the rest of the game shows for a
    // mixed prize. The amount goes with the single icon it counted.
    isPrize: function () {
        return this.rewardList.listRewards().length > 1;
    },

    createIcon: function () {
        if (this.isPrize()) {
            const prize = new cleverapps.Spine(bundles.prize.jsons.prize_json);
            prize.setAnimation(0, "idle", true);
            return prize;
        }

        const icon = this.rewardList.listRewards()[0].getIcon();
        icon.setAnchorPoint(0.5, 0.5);
        return icon;
    },

    // A chest keeps its contents out of sight, so it carries the button that lists them - the
    // amount text a single reward shows had already told that player what was coming. The
    // tooltip picks its own side of the icon, so the top row of the progress bar keeps it
    // on screen.
    createHelpButton: function () {
        const styles = cleverapps.styles.PassRewardIcon.helpButton;

        const helpButton = this.helpButton = new cleverapps.UI.HelpButton({
            callback: () => {
                cleverapps.tooltipManager.onClick(helpButton, { rewards: this.rewardList });
            }
        });
        helpButton.setScale(styles.scale);
        helpButton.baseScale = helpButton.scale;
        helpButton.setAlignment(styles);
        this.icon.addChild(helpButton);
    },

    createContent: function () {
        const styles = cleverapps.styles.PassRewardIcon;

        const icon = this.icon = this.createIcon();
        cleverapps.UI.fitToBox(icon, {
            width: styles.icon.width,
            height: styles.icon.height,
            maxScale: this.options.premium ? styles.icon.prem.scale : styles.icon.free.scale
        });
        icon.setAlignment(styles.icon);
        this.addChild(icon);

        if (this.isPrize()) {
            this.createHelpButton();
            return;
        }

        const msg = this.rewardList.listRewards()[0].getText(RewardType.DEFAULT_PREFIX);
        const font = this.options.font || cleverapps.styles.FONTS.PASS_REWARD_TEXT;
        if (cleverapps.UI.ImageFont.IsApplicable(font, msg)) {
            this.text = cleverapps.UI.generateImageText(msg, font);
        } else {
            this.text = cleverapps.UI.generateOnlyText(msg, font);
        }
        if (this.options.amountBg) {
            const amountBgSprite = new cc.Sprite(this.options.amountBg);
            amountBgSprite.setAlignment(styles.text);
            this.addChild(amountBgSprite);
            cleverapps.UI.fitToBox(this.text, amountBgSprite);
            this.text.setAlignment(amountBgSprite.width / 2, amountBgSprite.height / 2);
            amountBgSprite.addChild(this.text);
        } else {
            this.text.setAlignment(styles.text);
            this.addChild(this.text);
        }
    },

    setDiscolor: function (toggle) {
        if (toggle) {
            this.icon.setOpacity(120);
            this.icon.setColor(new cc.Color(0, 150, 255, 255));
        } else {
            this.icon.setOpacity(255);
            this.icon.setColor(new cc.Color(255, 255, 255, 255));
        }

        if (this.isPrize()) {
            return;
        }

        if (toggle) {
            this.text.setOpacity(120);
            this.text.setScale(0.8);
        } else {
            this.text.setScale(1);
            this.text.setOpacity(255);
        }
    },

    setAttention: function (image) {
        const styles = cleverapps.styles.PassRewardIcon.attention;

        if (this.attention) {
            this.attention.removeFromParent();
            delete this.attention;
        }

        if (image) {
            const attention = this.attention = new cc.Sprite(image);
            attention.setAlignment(styles);
            this.addChild(attention);
        }
    },

    setShining: function (toggle) {
        const styles = cleverapps.styles.PassRewardIcon.shining;

        if (this.shining) {
            this.shining.removeFromParent();
            delete this.shining;
        }

        if (toggle) {
            this.shining = StandartAnimations.rays(this, { skin: "white", size: styles.size });
            this.shining.setAlignment(styles);
        }
    },

    setFlying: function (toggle) {
        const styles = cleverapps.styles.PassRewardIcon.flying;

        if (this.flyingAction) {
            this.stopAction(this.flyingAction);
            delete this.flyingAction;
        }

        if (toggle) {
            this.flyingAction = this.runAction(new cc.Sequence(
                new cc.DelayTime(Math.random() * 1.5),
                new cc.CallFunc(function () {
                    this.flyingAction = this.runAction(new cc.RepeatForever(new cc.Sequence(
                        new cc.CallFunc(function () {
                            this.icon.runAction(new cc.Sequence(
                                new cc.MoveBy(3, 0, styles.offsetY),
                                new cc.CallFunc(function () {
                                    if (Math.random() < 0.7 / this.passLogic.countAvailableRewards()) {
                                        this.icon.runAction(new cc.Sequence(
                                            new cc.RotateBy(0.25, 10),
                                            new cc.RotateBy(0.25, -10),
                                            new cc.RotateBy(0.25, 10),
                                            new cc.RotateBy(0.25, -10)
                                        ));
                                    }
                                }, this),
                                new cc.MoveBy(1.5, 0, -styles.offsetY)
                            ));
                        }, this),
                        new cc.DelayTime(4.5)
                    )));
                }, this)
            ));
        }
    },

    setClaimable: function (toggle, disable) {
        this.setClaimButton(toggle, disable);

        if (toggle && !disable) {
            cleverapps.UI.onClick(this, this.claimReward.bind(this));
        }
    },

    setClaimButton: function (toggle, disable) {
        if (this.claimButton) {
            this.claimButton.removeFromParent();
            this.claimButton = undefined;
        }

        if (toggle) {
            const styles = cleverapps.styles.PassRewardIcon.claimButton;

            const claimButton = this.claimButton = new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.small_button_green,
                width: styles.width,
                height: styles.height,
                text: Messages.get("Claim"),
                onClicked: this.claimReward.bind(this)
            });
            claimButton.setAnchorPoint(0.5, 0.5);
            claimButton.setAlignment(styles);
            this.addChild(claimButton);

            if (disable) {
                claimButton.disable();
            }
        }
    },

    updateState: function (level) {
        const shownLevel = level !== undefined ? level : this.passLogic.shownProgress.level;
        let state;

        if (this.options.level < shownLevel) {
            if (this.passLogic.hasReward(this.options.level, this.options.premium)) {
                if (this.options.premium && !this.passLogic.hasPremium()) {
                    state = "premium_required";
                } else {
                    state = "fresh";
                }
            } else {
                state = "gained";
            }
        }

        cleverapps.pointerManager.removeAll(this);

        this.setDiscolor(false);
        this.setAttention();
        this.setShining(false);
        this.setFlying(false);
        this.setClaimable(false);

        switch (state) {
            case "premium_required":
                this.setClaimable(true, false);
                break;

            case "fresh":
                this.setShining(true);
                this.setFlying(true);
                this.setClaimable(true, false);
                break;

            case "gained":
                this.setAttention(bundles.reward_icons_pass.frames.prize_checkmark_png);
                break;

            default:
                this.setDiscolor(true);
                cleverapps.tooltipManager.create(this, {
                    text: Messages.get(`PassWindow.moreItemsToolTip.${this.passLogic.mission.collectItemName}`)
                });
        }
    },

    openAnimation: function () {
        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.2),
            new cc.ScaleTo(0.2, 1)
        ));

        if (this.claimButton) {
            this.claimButton.setVisible(false);
            this.claimButton.runAction(new cc.Sequence(
                new cc.DelayTime(0.4),
                new cc.Show()
            ));
        }
    },

    claimReward: function () {
        if (this.passLogic.shownProgress.level < this.options.level) {
            return;
        }

        if (this.options.premium && !this.passLogic.hasPremium()) {
            cleverapps.focusManager.display({
                focus: "PassBuyTicketWindow",
                stack: true,
                action: (f) => {
                    new PassBuyTicketWindow(this.passLogic);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
            return;
        }

        const prize = this.passLogic.takeLevelReward(this.options.level, this.options.premium);
        if (!prize) {
            return;
        }

        const prizeImage = this.createIcon();
        this.addChild(prizeImage);
        prizeImage.setPosition(this.icon.getPosition());
        prizeImage.setScale(this.icon.getScale());
        prizeImage.setAnchorPoint(this.icon.anchorX, this.icon.anchorY);

        this.rewardList.receiveRewards();
        const delay = Math.max(this.rewardList.collectRewardsAnimation(prizeImage) / 1000, 0.9);

        // A chest is off the tile only while its contents are in the air - the rewards fly out
        // of the empty space it held, then it is back to mark the stage, the way a single
        // reward's icon never leaves. prizeImage stays on as where the flight starts, the
        // animations measuring it to place and size what flies; it just has nothing to show.
        if (this.isPrize()) {
            this.icon.setVisible(false);
            this.helpButton.setVisible(false);
            prizeImage.setVisible(false);

            this.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.CallFunc(() => {
                    this.icon.setVisible(true);
                    this.helpButton.setVisible(true);
                })
            ));
        }

        if (!prize.unit || this.passLogic.mission.mainWorldReward) {
            this.updateState();
            this.passLogic.onHideFinger();
            this.passLogic.onShowFinger();
        } else {
            const currentWindow = cleverapps.focusManager.currentWindow();
            const windowComponent = ComponentMap.get(currentWindow, WindowComponent);
            windowComponent.hideWindow();
            currentWindow.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.CallFunc(() => {
                    if (this.passLogic.checkComplete()) {
                        currentWindow.close();
                    } else {
                        windowComponent.displayWindow();
                    }
                })
            ));
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PASS_REWARD_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.PassRewardIcon = {
    icon: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 20 },
        width: 180,
        height: 180,
        free: { scale: 1.1 },
        prem: { scale: 1.2 }
    },

    text: {
        x: { align: "right", dx: 0 },
        y: { align: "bottom", dy: -2 },

        bgScale: 3
    },

    helpButton: {
        x: { align: "right", dx: 10 },
        y: { align: "top", dy: 10 },
        scale: 0.7
    },

    attention: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -45 }
    },

    shining: {
        x: { align: "center", dx: -8 },
        y: { align: "center", dy: 0 },
        size: 100
    },

    flying: {
        offsetY: 8
    },

    claimButton: {
        width: 170,
        height: 60,
        x: { align: "center" },
        y: { align: "bottom", dy: -58 }
    }
};
